import {
    addFile,
    editVariationOrder,
    removeFile
} from "./actions";

import ItemListView from "../../../components/ItemListView/ItemListView.vue"
import ItemView from "../../../components/ItemView/ItemView.vue"

const dataFields = [{
    "label": "Number",
    "key": "Number"
}, {
    "label": "Primary Commercial / Job Number",
    "key": "Commercial",
    "link": "Database/Commercials/:CommercialID"
}, {
    "label": "Linked Purchase Order",
    "key": "PurchaseOrder",
    "link": "Database/PurchaseOrders/:PurchaseOrderID"
}, {
    "label": "Customer",
    "key": "Customer"
}, {
    "label": "Quote Price",
    "key": "Quote.Price",
    "type": "currency",
    "currencyType": "£"
}, {
    "label": "Percentage Invoiced",
    "key": "PercentageInvoiced"
}, {
    "label": "Percantage Paid",
    "key": "PercentagePaid"
}];

const menuActions = [
    {
        "label": "Edit Variation Order",
        "action": editVariationOrder
    }
];
const files = {
    "label": "Supporting Files",
    "key": "Files",
    "local": true,
    "actions": [{
        "label": "Add File",
        "action": addFile
    }],
    "headers": [{
        "headerName": "File Name",
        "field": "Name"
    }],
    "rowActions": [{
        "label": "Open File",
        async action({ db, rowItem, pageItem }) {
            let url = await db.download(`Database/VariationOrders/${pageItem.ID}/Files/${rowItem.ID}/${rowItem.Name}`);
            window.open(url, "__blank");
        }
    }, {
        "label": "Remove File",
        "action": removeFile
    }]
};

export default [{
    "path": "/Database/VariationOrders",
    "component": {...ItemListView},
    "name": "Variation Orders",
    "meta": {
        "app": "Database",
        "name": "Variation Orders",
        "sideNav": true,
        "appSwitcher": false,
        "icon": "database",
        "tableSettings": "VariationOrders",
        "sideNavSection": "Projects",
        "dataPath": "Database/VariationOrders",
        "selectionRoute": "Database/VariationOrders/{ID}",
        lock(user) {
            return [user?.Security?.Database?.Projects !== true, "Cannot view this area"]
        }
    }
}, {
    "path": "/Database/VariationOrders/:id",
    "component": ItemView,
    "name": "Variation Order",
    "meta": {
        "app": "Database",
        "name": "Variation Orders",
        "dataPath": "Database/VariationOrders",
        "selectionRoute": "Database/VariationOrders/{ID}",
        title(item) {
            return `Variation Order: ${item.Number}`
        },
        "dataFields": dataFields,
        "menuActions": menuActions,
        "attachedItems": {
            "Files": {
                "attachables": [files]
            }
        }
    }
}];
